import { motion } from "framer-motion";

const REASONS = [
  {
    n: "01",
    title: "High-ROI Model",
    body: "40–50% OPEX reduction with superior on-ground results — proven across multiple pharma companies.",
  },
  {
    n: "02",
    title: "3D Phygital Approach",
    body: "HCP + Digital + Channel integration creates holistic brand engagement no single channel can match.",
  },
  {
    n: "03",
    title: "Lifecycle Expertise",
    body: "Deep specialization in mature & tail-end brand revitalization — this is all we do, and we do it exceptionally well.",
  },
  {
    n: "04",
    title: "Young Talent Advantage",
    body: "Highly motivated pharmacy graduates from Tier 2–3 cities, locally rooted with growth ambition.",
  },
  {
    n: "05",
    title: "Performance-Based Economics",
    body: "Revenue-sharing model transforms fixed costs into variable, outcome-aligned investments.",
  },
  {
    n: "06",
    title: "Extra-Urban Reach",
    body: "300+ market HQs with deep penetration into Tier 2–4 cities others rarely cover.",
  },
];

export default function WhyMedstry() {
  return (
    <section className="py-20 md:py-32" data-testid="why-medstry-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 mb-14 md:mb-20 items-end">
          <div className="md:col-span-6">
            <div className="text-xs font-bold uppercase tracking-[0.2em] text-teal-700 mb-3">
              Why Medstry
            </div>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-extrabold leading-[1.02] text-slate-900">
              Six reasons pharma <br />
              <span className="font-editorial italic font-medium text-slate-700">leaders choose us.</span>
            </h2>
          </div>
          <div className="md:col-span-5 md:col-start-8">
            <p className="text-base md:text-lg text-slate-600 leading-relaxed">
              We are not a generic CSO. We are specialists — in the segment of pharma that everyone
              else has stopped investing in.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-slate-200">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.n}
              initial={{ opacity: 0, y: 14 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: (i % 3) * 0.06 }}
              data-testid={`why-${r.n}`}
              className="bg-white p-8 md:p-10 group hover:bg-slate-50 transition-colors"
            >
              <div className="flex items-center gap-4 mb-6">
                <div className="font-display text-sm font-extrabold tnum text-teal-700 tracking-[0.1em]">
                  {r.n}
                </div>
                <div className="h-px bg-slate-300 flex-1 group-hover:bg-slate-900 transition-colors" />
              </div>
              <h3 className="font-display text-xl md:text-2xl font-bold text-slate-900 mb-3 leading-tight">
                {r.title}
              </h3>
              <p className="text-[15px] text-slate-600 leading-relaxed">{r.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
